import { LayoutDto, ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/LayoutContainerAdapter';
import { createLayout, CreateLayoutPayload, layoutCreated, layoutCreateFailed } from '../../actions/layout/createLayout';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* createLayoutSaga({ payload }: Action<CreateLayoutPayload>) {
  const { placeUuid, layoutUuid, label, type } = payload;
  const token = yield getAuthenticationToken();
  const layoutDto: LayoutDto = { placeUuid, uuid: layoutUuid, label, type, isOpen: false };
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.createLayout, token, { layoutDto });
  if (!response.error) {
    const { layoutContainerDto } = response;
    yield put(layoutCreated({ placeUuid, layoutUuid, ...fromDto(layoutContainerDto) }));
  } else {
    yield put(layoutCreateFailed({ layoutUuid }));
  }
}

export default function* watchCreateLayout() {
  yield takeEvery(createLayout, createLayoutSaga);
}
